module.exports = __webpack_public_path__ + "static_pest_wiki_details/img/baiyiyufang_type01.08c3944.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/product_info/baiyiyufang_type01.jpg
// module id = hJxI
// module chunks = 0